import removeTrailingSlash from 'util/removeTrailingSlash'
import removeLeadingSlash from 'util/removeLeadingSlash'
import removeLeadingLang from 'util/removeLeadingLang'

export default function cleanSlug (string) {
  return removeLeadingLang(removeLeadingSlash(removeTrailingSlash(string)))
}



// WEBPACK FOOTER //
// ./client/util/cleanSlug.js